import { Classroom } from '@teetsh/app/src/types/classroom';
import { getCycleFromClassrooms } from './getCycleFromClassrooms';
import { CJEvent } from '@teetsh/app/src/types/event';

export function getCycle(
  values: Pick<CJEvent, 'cycle' | 'classroomIds'>,
  allClassrooms: Classroom[],
) {
  const cycle = values.cycle;
  const classroomIds = values.classroomIds || [];

  if (cycle) {
    return cycle;
  }

  const selectedClassrooms = allClassrooms.filter(classroom =>
    classroomIds.includes(classroom.id),
  );
  if (selectedClassrooms.length > 0) {
    return getCycleFromClassrooms(selectedClassrooms);
  }
  return getCycleFromClassrooms(allClassrooms);
}
